var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-form',[_c('FormInput',{attrs:{"readonly":true,"label":'Wallet ID',"placeholder":'pub-4278966745452923'}}),_c('FormInput',{attrs:{"readonly":true,"label":'Wallet username',"placeholder":'Vyouzwise343536'}}),_c('PaymentMethods')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }